import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "index",
    component: () => import("@views/Index.vue"),
    // 添加单独的路由守卫
    // beforeEnter: () => {
    // http.post('admin/auth_login')
    // },
    // redirect: '/index',
    // children: [
    //   {
    //     path: 'index',
    //     name: 'index',
    //     component: () => import('@views/Index.vue'),
    //   },
    // ],
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import("@views/Aboutus.vue"),
  },
  {
    path: "/contactsus",
    name: "contactsus",
    component: () => import("@views/Contactsus.vue"),
  },
  {
    path: "/coaxial",
    name: "coaxial",
    component: () => import("@views/Coaxial.vue"),
  },
  // {
  //   path: "/test",
  //   name: "test",
  //   component: () => import("@views/Test.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
